import script from "./ModalFooterActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFooterActions.vue?vue&type=script&setup=true&lang=js"

import "./ModalFooterActions.vue?vue&type=style&index=0&id=755eda18&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755eda18"]])

export default __exports__